/** The card fields the labels read (a `SavedPaymentMethod` from the API). */
export interface CardLabelFields {
  brand: string;
  last4: string;
  expMonth: number;
  expYear: number;
  wallet?: string | null;
  isExpired: boolean;
}

const BRAND_NAMES: Record<string, string> = {
  amex: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
};

const WALLET_NAMES: Record<string, string> = {
  apple_pay: 'Apple Pay',
  google_pay: 'Google Pay',
};

/** "Visa •••• 4242", with the wallet in front when the card came from one. */
export function cardTitle(card: Pick<CardLabelFields, 'brand' | 'last4' | 'wallet'>): string {
  const brand = BRAND_NAMES[card.brand?.toLowerCase()] ?? (card.brand || 'Card');
  const title = `${brand} •••• ${card.last4}`;
  const wallet = card.wallet ? WALLET_NAMES[card.wallet] : undefined;
  return wallet ? `${wallet} (${title})` : title;
}

/** "Expires 12/27", "Expired 01/20". */
export function cardExpiry(
  card: Pick<CardLabelFields, 'expMonth' | 'expYear' | 'isExpired'>,
): string {
  const mm = String(card.expMonth).padStart(2, '0');
  const yy = String(card.expYear).slice(-2);
  return `${card.isExpired ? 'Expired' : 'Expires'} ${mm}/${yy}`;
}
